





























import Vue from 'vue';
import pipeline from '@/pipeline';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import EssayThemeSelectionForm from '@/components/forms/EssayThemeSelectionForm.vue';
import { EssayTheme } from '@/store/modules/essay/state';
import { Toast } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    BackButton,
    EssayThemeSelectionForm,
    Toast,
  },
  data() {
    return { error: false };
  },
  computed: {
    availableEssayThemes(): EssayTheme[] {
      return this.$store.getters.availableEssayThemes || [];
    },
    selectedEssayTheme(): string {
      return this.$store.getters.selectedEssayTheme?.id;
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_ESSAY_THEMES');
  },
  methods: {
    async selectedHandler(essayTheme: EssayTheme) {
      await this.$store
        .dispatch('UPDATE_ESSAY_THEME', { essayTheme })
        .catch(error => this.errorHandler(error));

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
